export function SMLogo({ className = "w-10 h-10" }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Orange gradient for background */}
        <linearGradient id="orangeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fb923c" />
          <stop offset="50%" stopColor="#f97316" />
          <stop offset="100%" stopColor="#ea6a0d" />
        </linearGradient>
        
        {/* Blue gradient for bird */}
        <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#1e40af" />
        </linearGradient>

        {/* Shadow filter */}
        <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
          <feOffset dx="0" dy="2" result="offsetblur"/>
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.3"/>
          </feComponentTransfer>
          <feMerge>
            <feMergeNode/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Rounded square background with orange gradient */}
      <rect 
        x="8" 
        y="8" 
        width="104" 
        height="104" 
        rx="18" 
        ry="18" 
        fill="url(#orangeGradient)" 
        filter="url(#shadow)"
      />
      
      {/* Inner lighter border for depth */}
      <rect 
        x="12" 
        y="12" 
        width="96" 
        height="96" 
        rx="14" 
        ry="14" 
        fill="none" 
        stroke="rgba(255, 255, 255, 0.2)" 
        strokeWidth="1"
      />
      
      {/* Blue bird silhouette */}
      <g filter="url(#shadow)">
        {/* Bird body */}
        <ellipse 
          cx="60" 
          cy="62" 
          rx="18" 
          ry="16" 
          fill="url(#blueGradient)"
        />
        
        {/* Bird head */}
        <circle 
          cx="72" 
          cy="48" 
          r="12" 
          fill="url(#blueGradient)"
        />
        
        {/* Bird beak */}
        <path 
          d="M 82 46 L 92 44 L 84 50 Z" 
          fill="#1e3a8a"
        />
        
        {/* Bird eye */}
        <circle 
          cx="76" 
          cy="46" 
          r="2.5" 
          fill="white"
        />
        
        {/* Bird wing (upper part) */}
        <ellipse 
          cx="58" 
          cy="58" 
          rx="14" 
          ry="10" 
          fill="#1e40af"
          transform="rotate(-25 58 58)"
        />
        
        {/* Bird tail */}
        <path 
          d="M 44 64 Q 38 66 35 70 Q 38 68 42 66 Q 40 70 38 74 Q 42 70 44 68 Z" 
          fill="#1e40af"
        />
        
        {/* Bird legs */}
        <line 
          x1="56" 
          y1="76" 
          x2="56" 
          y2="84" 
          stroke="#1e3a8a" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
        <line 
          x1="64" 
          y1="76" 
          x2="64" 
          y2="84" 
          stroke="#1e3a8a" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
        
        {/* Bird feet */}
        <path 
          d="M 52 84 L 56 84 L 60 84" 
          stroke="#1e3a8a" 
          strokeWidth="1.5" 
          strokeLinecap="round"
          fill="none"
        />
        <path 
          d="M 60 84 L 64 84 L 68 84" 
          stroke="#1e3a8a" 
          strokeWidth="1.5" 
          strokeLinecap="round"
          fill="none"
        />
      </g>
      
      {/* Subtle highlight on top left for 3D effect */}
      <rect 
        x="8" 
        y="8" 
        width="104" 
        height="52" 
        rx="18" 
        ry="18" 
        fill="url(#topHighlight)" 
        opacity="0.15"
      />
      
      <defs>
        <linearGradient id="topHighlight" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="white" stopOpacity="1"/>
          <stop offset="100%" stopColor="white" stopOpacity="0"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
